<template>
  <div>
    <div class="getPrize-background">
      <div class="getPrize-rule">
        <!-- <div class="getPrize-rulename"></div> -->
        <img class="getPrize-ruleimg" src="/static/rule.png" />
      </div>
     <div class="getPrize-center" v-if="count>0">
        <img class="getPrize-img" src="/static/yueka.png" />
        <div class="getPrize-name">{{prize.prize.prize}}</div>
        <input class="getPrize-input" placeholder="请输入充值号码" v-model="phonenum" />
        <div class="getPrize-botton" @click="buttonClicked ? '' : recharge()">充值</div>
      </div>
      <div class="getPrize-center" v-else>
        <img class="getPrize-noneimg" src="/static/nothing.png"/>
        <div class="getPrize-nonetext">暂无可领奖品</div>
      </div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        userInfo: {},
        mobile: "",
        prize: {},
        phonenum: "",
        buttonClicked: false, // 防止支付重复点击,默认为false
        count:0
      }
    },
    created() {
      this.request("getUserInfo")

    },
    mounted() {

    },
    methods: {
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      recharge() {
        var order_param = {} //下单参数
        var that = this
         this.buttonClickedFun(1000) // 防止重复点击
        if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
          this.$toast({
            message: '手机号格式错误'
          })
          return
        }
        order_param.id = that.prize.id
        order_param.recharge_number = that.phonenum
        this.request("receivePrize", order_param)
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                console.log("user", res.data.mobile)
                that.userInfo = res.data
                that.mobile = res.data.mobile
                this.getMesg()
              }
            }, true)
            break
            //获取奖品信息
          case 'getPrize':
            httper.get('prize/index', requestData, res => {
              if (res.code == 0) {
                console.log("Number(res.data.prize.count)",Number(res.data.count) )
                if(Number(res.data.count)>0){
                  that.prize = res.data.prize
                  that.count = Number(res.data.count)
                }
              }
            })
            break
            //领取奖品
          case 'receivePrize':
            httper.post('prize/receive', requestData, res => {
              if (res.code == 0) {
                this.$toast({
                  message: '充值成功！',
                });
                this.getMesg()
                // that.$router.push({
                //   path: "/receiveSuccess"
                // })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      getMesg() {
        let that = this
        console.log("!this.mobile", that.mobile)
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          this.request("getPrize")
        }
      },
    }
  }
</script>

<style>
  .getPrize-background {
    width: 100%;
    background-image: url(../../../static/PrizeBG.png);
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
  }

  .getPrize-rule {
    width: 100px;
    height: 25px;
    position: absolute;
    top: 10px;
    right: 10px;
    margin-right: 20px;
  }

  .getPrize-rulename {}

  .getPrize-ruleimg {
    width: 100%;
    height: 100%;
    /* display: flex;
    justify-content: flex-end;
    margin-right: 20px; */
  }

  .getPrize-center {
    width: calc(100% - 50px);
    margin: 20px 25px;
    background-image: url(../../../static/priceCenter.png);
    background-size: 100% 100%;
    height: 61%;
    position: absolute;
    top: 32%;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .getPrize-img {
    width: 100px;
    height: 100px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .getPrize-name {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .getPrize-input {
    width: calc(100% - 40px);
    margin: 20px;
    height: 40px;
    border: 1px solid #ffa63d;
    font-size: 18px;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  input {
    border: none;
    outline: none;
  }

  input::-webkit-input-placeholder {
    font-size: 18px;
    color: #bbbbbb;
    text-align: center;
  }

  .getPrize-botton {
    width: calc(100% - 40px);
    margin: 0 20px;
    height: 40px;
    background-color: #ef0023;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #FFFFFF;
    border-radius: 5px;
  }
/*  .getPrize-none{

  } */
  .getPrize-noneimg{
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  .getPrize-nonetext{
    font-weight: bold;
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/getPrize/getPrize.vue